import React, { useContext, useEffect, useState } from "react";
import "../../../css/campaign.css";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";
import moment from "moment";
import { getCampaignsList } from "../live-campaign-repository";
import { useNavigate } from "react-router-dom";
import { UserDetailsContext } from "../../context/user-details-context";
import CommonPagination from "../../common/common-pagination";
import Badge from '@mui/material/Badge';
import MailIcon from '@mui/icons-material/Mail';
import VisibilityIcon from '@mui/icons-material/Visibility';

function LiveCampaignList() {
  const navigate = useNavigate();
  const { loggedUser } = useContext(UserDetailsContext);
  const pathname = window.location.pathname;
  const pathSegments = pathname.split('/');
  const startPath = '/' + pathSegments[1];
  const [campaignList, setCampaignList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCampaigns, setTotalCampaigns] = useState(0);
  const recordsPerPage = 5;

  useEffect(() => {
    setIsLoading(true);
    getCampaignsList(setCampaignList, setTotalCampaigns, setIsLoading, currentPage, recordsPerPage);
  }, [currentPage, recordsPerPage]);

  const handleCampaignClick = (campaign) => {
    navigate(`${startPath}/details`, { state: { campaignid: campaign.campaignId } });
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleCampaignApplication = (campaignId, campaignName, noOfCreators, campaignClosed) => {
    const pathSegments = pathname.split('/');
    const startPath = '/' + pathSegments[1];
    navigate(`${startPath}/applications`, { state: { campaignId, campaignName, noOfCreators, campaignClosed } });
  }

  return (
    <>
      {!loggedUser ?
        <>
        </>
        : <div className="campaign-page">
          <h1>Campaigns</h1>
          <div className="campaign-list-hr"></div>
          {isLoading || !loggedUser ? (
            <div className="data-loading">
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
              </Box>
            </div>
          ) : (
            campaignList.length === 0 ?
              <>
                <h1 className="text-center">No Live Campaigns</h1>
              </>
              : <>
                <div className="campaign-list-holder">
                  {campaignList.map((campaign, index) => (
                    <div
                      className="campaign-list-box"
                      key={index}
                    >
                      <div className="campaigns-list">
                        <div className="list-header-content">
                          <div className="list-title" onClick={() => handleCampaignClick(campaign)}>
                            <div className="campaign-name">{campaign.campaignName}</div>
                            <div className="campaign-list-row">
                              <div className="campaign-start-date first-element">
                                <label>Campaign approved: </label>{moment(campaign.approvedDate).format("ll")}
                              </div>
                              <div>
                                <label>Last date of application: </label>{moment(campaign.lastDateOfApplication).format("ll")}
                              </div>
                            </div>
                            <div className="campaign-list-row">
                              <div className="first-element"><label>Project Type: </label><span>{campaign.projectType?.projectType}</span></div>
                              <div><label>Target Types: </label><span>
                                {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') ? campaign.categoryTypes.join(', ') : ''}
                                {campaign.categoryTypes && campaign.categoryTypes.some(item => item !== '') && campaign.customCategory && campaign.customCategory.some(item => item !== '') ? ', ' : ''}
                                {campaign.customCategory && campaign.customCategory.some(item => item !== '') ? campaign.customCategory.filter(item => item !== '').map(item => item.replace(/"/g, '')).join(', ') : ''}
                              </span></div>
                            </div>
                          </div>
                          <div className="campaign-list-button">
                            <div className="view-campaign-row">
                              <Badge onClick={() => { handleCampaignApplication(campaign.campaignId, campaign.campaignName, campaign.creators, campaign.campaignClosed); }}
                                sx={{ cursor: 'pointer' }}
                                color="secondary" badgeContent={campaign.campaignApplicantsCount} showZero>
                                <MailIcon />
                              </Badge>
                              <Tooltip title="View Campaign" arrow>
                                <IconButton onClick={(e) => { handleCampaignClick(campaign) }}>
                                  <VisibilityIcon sx={{ color: '#9c27b0', fontSize: '1.9rem' }} />
                                </IconButton>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <CommonPagination
                  currentPage={currentPage}
                  totalPages={Math.ceil(totalCampaigns / recordsPerPage)}
                  handlePageChange={handlePageChange}
                />
              </>
          )}
        </div>
      }
    </>
  );
}

export default LiveCampaignList;
